module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card flex-row flex-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-block px-2"
  }, [_c('div', {
    staticClass: "card-title",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('prime.recommend_notice.description'))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "card-actions"
  }, [_c('button', {
    staticClass: "btn cl-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('closeSnackBar')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.recommend_notice.cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn cl-btn close-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('okSnackBar')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('prime.recommend_notice.confirm')))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header border-0"
  }, [_c('img', {
    staticClass: "icon",
    attrs: {
      "src": "/static/images/ic-snackbar-sam.png",
      "alt": "publisher-profile"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-98eb05dc","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PrimeSnackBar.vue
// module id = 1600
// module chunks = 1